var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVariant9 = function SvgIconVariant9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.207 3.793a1 1 0 0 0-1.414 1.414l7.5 7.5a1 1 0 0 0 1.414 0l7.5-7.5a1 1 0 0 0-1.414-1.414L12 10.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.207 11.293a1 1 0 0 0-1.414 1.414l7.5 7.5a1 1 0 0 0 1.414 0l7.5-7.5a1 1 0 0 0-1.414-1.414L12 18.086z"
  }))));
};
export default SvgIconVariant9;